import React, { useState, useEffect } from 'react';
import CommonModal from '../modalLayout/CommonModal';
import Form from 'react-bootstrap/Form';
import Button from '../buttons/button';
import {
  useCreateFaqMutation,
  useGetFaqByIdQuery,
  useUpdateFaqMutation,
  useGetFaqCategoriesQuery,
} from '../../../app/faqApi/faqApi';
import { showToast } from '../../../helpers/Utils';

const AddFaqModal = ({ show, handleClose, setShow, faqId,categoryId,categoryName }) => {
  console.log(categoryId,"categoryId--->");
  
  const [formData, setFormData] = useState({ title: '', content: '', category: '' });
console.log(formData,"formData");

  const [createFaq, { isLoading: isCreating }] = useCreateFaqMutation();
  const [updateFaq, { isLoading: isUpdating }] = useUpdateFaqMutation();
  const { data: FaqCategories, isLoading: isCategorizing } = useGetFaqCategoriesQuery();

  const { data: faqDetail, isFetching: isFetchingFaq } = useGetFaqByIdQuery(faqId, {
    skip: !faqId,
  });
console.log(faqDetail,"faqDetail","faqId",faqId);

  // Populate form when editing
  useEffect(() => {
    console.log(categoryId,"idinside");
    
    if (faqDetail) {
      setFormData({
        title: faqDetail?.data?.title || '',
        content: faqDetail?.data?.content || '',
        category: categoryId,
      });
    } else if (!faqId) {
      setFormData({ title: '', content: '', category: categoryId });
    }
  }, [faqId, faqDetail, show]);
  const matchedCategory = FaqCategories?.data?.find((cat) => cat._id === categoryId);
const matchedCategoryName = matchedCategory?.name || '';
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { title, content } = formData;

    if (!title || !content ) {
      showToast('All fields are required, including category.', 'error');
      return;
    }

    try {
      if (faqId) {
        await updateFaq({ faqId, ...formData }).unwrap();
        showToast('FAQ updated successfully', 'success');
      } else {
        await createFaq(formData).unwrap();
        showToast('FAQ added successfully', 'success');
      }
      handleClose();
    } catch (err) {
      showToast(err?.data?.message || 'Something went wrong', 'error');
    } 
  }; 

  return (
    <CommonModal show={show} handleClose={handleClose} setShow={setShow} title={faqId ? 'Edit FAQ' : 'Add FAQ'}>
      {faqId && isFetchingFaq ? (
        <div className="text-center py-4">Loading FAQ data...</div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Select Category</Form.Label>
            <Form.Select
            disabled={true}
              value={formData.category}
              // onChange={(e) => setFormData({ ...formData, category: e.target.value })}
            >
              <option value={categoryId}>{matchedCategoryName}</option>
              {/* {FaqCategories?.data?.map((option) => (
                <option key={option._id} value={option._id}>
                  {option.name}
                </option>
              ))} */}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Question</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter question"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Answer</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter answer"
              value={formData.content}
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
            />
          </Form.Group>

          <div className="text-end d-flex justify-content-end gap-3">
            <Button onClick={() => setShow(false)} label="Cancel" className="borderedBtn" />
            <Button type="submit" label={(isCreating || isUpdating) ? 'Saving...' : 'Save FAQ'} />
          </div>
        </Form>
      )}
    </CommonModal>
  );
};

export default AddFaqModal;
